export const CLI_NAME = "directive";
export const CLI_ALIAS = "dr";
export const PACKAGE_NAME = "@directive-run/cli";
export const SECTION_START = "<!-- directive:start -->";
export const SECTION_END = "<!-- directive:end -->";
